<script>
    import PatientEncounterPatientNotes from "../components/PatientEncounterPatientNotes.svelte";

    import PatientEncounterNotes from "../components/PatientEncounterNotes.svelte";

    export let patientID;
    export let patientHasNotes = false;
    export let encounterID;
    export let encounterHasNotes = false;
    export let reloadPatientDetails = () => {};
    export let encounterDoctorGroupId = null;
</script>

<div class="relative flex-1">
    <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 mt-4">
        <PatientEncounterPatientNotes
            {patientID}
            {patientHasNotes}
            {reloadPatientDetails}
        />

        <PatientEncounterNotes
            {encounterID}
            {encounterHasNotes}
            {reloadPatientDetails}
            {encounterDoctorGroupId}
        />
    </div>
</div>
